import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./Historique.css";
import { supabase } from "../cloudflareClient";
import Header from "../components/Header";

function Historique() {
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const history = useHistory();

  useEffect(() => {
    const fetchFactures = async () => {
      setLoading(true);
      setLoadError("");
      try {
      // Get current user
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) {
        setFactures([]);
        setLoading(false);
        return;
      }
      // Get entrepreneur for user
      const { data: entrepreneur } = await supabase
        .from("entrepreneur")
        .select("id")
        .eq("user_id", user.id)
        .single();
      if (!entrepreneur) {
        setFactures([]);
        setLoading(false);
        return;
      }
      // Get factures for entrepreneur
      const { data: facturesData, error: facturesError } = await supabase
        .from("factures")
        .select("*")
        .order("date", { ascending: false });
      if (facturesError) throw facturesError;
      setFactures(facturesData || []);
      } catch (error) {
        console.error("Erreur chargement historique:", error);
        setFactures([]);
        setLoadError(error.message || "Impossible de charger l'historique.");
      }
      setLoading(false);
    };
    fetchFactures();
  }, []);

  const handleOpenFacture = (facture) => {
    localStorage.setItem(
      "factureToEdit",
      JSON.stringify({
        ...facture,
        factureNumber: facture.facture_number, // for compatibility with editor
      })
    );
    history.push("/facteur-editeur");
  };

  const handleDeleteFacture = async (factureId) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cette facture ?")) return;
    await supabase.from("factures").delete().eq("id", factureId);
    setFactures((prev) => prev.filter((f) => f.id !== factureId));
  };

  return (
    <div className="historique-page">
      <Header activePage="historique" />
      <h2 className="titron">Historique des Factures</h2>
      {loading ? (
        <p>Chargement...</p>
      ) : loadError ? (
        <p role="alert">{loadError}</p>
      ) : factures.length === 0 ? (
        <p>Aucune facture enregistrée.</p>
      ) : (
        <table className="historique-table">
          <thead>
            <tr>
              <th>N° Facture</th>
              <th>Date</th>
              <th>Client</th>
              <th>Montant Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {factures.map((facture, idx) => (
              <tr key={idx}>
                <td>{facture.facture_number}</td>
                <td>{facture.date}</td>
                <td>{facture.client}</td>
                <td>
                  {Array.isArray(facture.items)
                    ? facture.items
                        .reduce(
                          (acc, item) =>
                            acc + Number(item.prix || 0) * Number(item.qte || 0),
                          0
                        )
                        .toFixed(2)
                    : "0.00"}{" "}
                  MAD
                </td>
                <td>
                  <div className="history-actions">
                    <button
                    className="history-action-btn history-action-edit"
                    onClick={() => handleOpenFacture(facture)}
                    title="Modifier la facture"
                  >
                    Éditer
                  </button>
                  <button
                    className="history-action-btn history-action-view"
                    onClick={() => facture.pdf_url && window.open(facture.pdf_url, '_blank')}
                    title="Voir le PDF"
                    disabled={!facture.pdf_url}
                  >
                    Voir PDF
                  </button>
                  <button
                    className="history-action-btn history-action-delete"
                    onClick={() => handleDeleteFacture(facture.id)}
                    title="Supprimer la facture"
                  >
                    Supprimer
                  </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Historique;
